import apiClient from './apiClient';

const inventoryService = {
    getAllItems: async (params = {}) => {
        try {
            const response = await apiClient.get('/inventory/items', { params });
            return response;
        } catch (error) {
            console.error('Error fetching inventory items:', error);
            throw error;
        }
    },

    getItemById: async (id) => {
        try {
            const response = await apiClient.get(`/inventory/items/${id}`);
            return response;
        } catch (error) {
            console.error(`Error fetching inventory item ${id}:`, error);
            throw error;
        }
    },

    addItem: async (itemData) => {
        try {
            const response = await apiClient.post('/inventory/items', itemData);
            return response;
        } catch (error) {
            console.error('Error adding inventory item:', error);
            throw error;
        }
    },

    updateItem: async (id, itemData) => {
        try {
            const response = await apiClient.put(`/inventory/items/${id}`, itemData);
            return response;
        } catch (error) {
            console.error(`Error updating inventory item ${id}:`, error);
            throw error;
        }
    },

    recordTransaction: async (transactionData) => {
        try {
            const response = await apiClient.post('/inventory/transactions', transactionData);
            return response;
        } catch (error) {
            console.error('Error recording inventory transaction:', error);
            throw error;
        }
    },

    getTransactions: async (itemId) => {
        try {
            const url = itemId ? `/inventory/items/${itemId}/movements` : '/inventory/stats';
            const response = await apiClient.get(url);
            return response;
        } catch (error) {
            console.error('Error fetching inventory transactions:', error);
            throw error;
        }
    },

    getStats: async () => {
        try {
            const response = await apiClient.get('/inventory/stats');
            return response;
        } catch (error) {
            console.error('Error fetching inventory stats:', error);
            throw error;
        }
    },

    getSuppliers: async () => {
        try {
            const response = await apiClient.get('/inventory/suppliers');
            return response;
        } catch (error) {
            console.error('Error fetching suppliers:', error);
            throw error;
        }
    },

    addSupplier: async (supplierData) => {
        try {
            const response = await apiClient.post('/inventory/suppliers', supplierData);
            return response;
        } catch (error) {
            console.error('Error adding supplier:', error);
            throw error;
        }
    },

    addStock: async (itemCode, stockData) => {
        try {
            const response = await apiClient.post(`/inventory/items/${itemCode}/add-stock`, stockData);
            return response;
        } catch (error) {
            console.error(`Error adding stock for ${itemCode}:`, error);
            throw error;
        }
    },

    removeStock: async (itemCode, stockData) => {
        try {
            const response = await apiClient.post(`/inventory/items/${itemCode}/remove-stock`, stockData);
            return response;
        } catch (error) {
            console.error(`Error removing stock for ${itemCode}:`, error);
            throw error;
        }
    },

    getCategories: async () => {
        try {
            const response = await apiClient.get('/inventory/categories');
            return response;
        } catch (error) {
            console.error('Error fetching inventory categories:', error);
            throw error;
        }
    },

    getModels: async () => {
        try {
            const response = await apiClient.get('/inventory/models');
            return response;
        } catch (error) {
            console.error('Error fetching models:', error);
            throw error;
        }
    },

    // Inventory Control Panel: parts the upcoming services need vs stock.
    // `force` skips the server's 60s cache.
    getControlPanel: async (force = false) => {
        try {
            const response = await apiClient.get(`/inventory/control-panel${force ? '?force=1' : ''}`);
            return response;
        } catch (error) {
            console.error('Error fetching inventory control panel:', error);
            throw error;
        }
    }
};

export default inventoryService;
